import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import FailedToLinkContent from 'Components/ComponentLibrary/Organisms/FailedToLinkContent/FailedToLinkContent';


const FailedToLinkContentWrapper = () => {
  const {
    pageContentResource,
  } = usePageContentContext();

  return (
    <FailedToLinkContent resource={pageContentResource} />
  );
};

export default FailedToLinkContentWrapper;
